import { chatKindOf } from '@bt-common/schemas/wa/chat-kind';
/**
 * Pulled out of WhatsappThunks.ts as its own module (rather than living
 * module-scope inside WhatsappThunks.ts) so it can be unit-tested without
 * dragging in that file's heavy transitive import chain (backend-api,
 * analytics-service, etc., which touch env config at module load time and
 * are otherwise only importable behind a wall of virtual mocks).
 */

/** Ids to report for a drip reply-exit: the sender's identity equivalents,
 *  plus the group chat id when the inbound is a group message (a group
 *  audience's recipient is the @g.us id, which the individual sender never
 *  matches). */
export function buildDripReplyIds(senderEquivalents: Iterable<string>, chatId?: string): string[] {
    const ids = new Set(senderEquivalents);
    if (chatId && chatKindOf(chatId) === 'group') ids.add(chatId);
    return [...ids].filter(Boolean);
}
